import email from "../assets/email.png";
import mobile from "../assets/mobile.png";
import react from "../assets/react.png";
import redux from "../assets/redux.png";
import sass from "../assets/sass.png";
import profile from "../assets/profile.png";
import circle from "../assets/circle.svg";
import logo from "../assets/logo.png";
import logodark from "../assets/logodark.png";
import flutter from "../assets/flutter.png"
import git from "../assets/git.png"
import mui from "../assets/mui.png"
import node from "../assets/node.png"
import python from "../assets/python.png"
export default {
  email,
  mobile,
  react,
  redux,
  sass,
  profile,
  circle,
  logo,
  logodark,
  flutter,
  git,
  mui,
  node,
  python
};
